module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("px9BB"))).then(() => parcelRequire('2wqpp'));